import React from 'react';
import TemplatePage from '../../components/TemplatePage/TemplatePage';
import { humanitiesData } from '../../data/departmentalData/humanities';

const Humanities = () => {
  return <TemplatePage data={humanitiesData} />;
};

export default Humanities;
